import { FC, Fragment, JSX } from "react";

type Step = {
  key: number;
  label: string;
  content: JSX.Element;
};

type Props = {
  current: number;
  steps: Step[];
};

export const Steps: FC<Props> = ({ current, steps }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center">
        {steps.map((_step, index) => (
          <Fragment key={_step.key}>
            <div
              className={`flex items-center justify-center w-8 h-8 rounded-full ${
                current >= _step.key
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              {_step.key}
            </div>
            {index !== steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 ${
                  current >= _step.key + 1 ? "bg-blue-600" : "bg-gray-200"
                }`}
              />
            )}
          </Fragment>
        ))}
      </div>
      <div className="flex justify-between mt-2 text-sm">
        {steps.map((_step) => (
          <div
            key={_step.key}
            className={
              current >= _step.key
                ? "text-blue-600 font-medium"
                : "text-gray-500"
            }
          >
            {_step.label}
          </div>
        ))}
      </div>
    </div>
  );
};
